import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import Sortable from "sortablejs";
import { LI } from "../../../AbstractElements";
import { HandleList } from "../../../Constants/Constants";
import { handlelistItems, HandleTreeData } from "../../../Data/BonusUi/Tree";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SortableHandleList = () => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      Sortable.create(listRef.current, {
        handle: ".handle",
        animation: 150,
      });
    }
  }, []);

  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={HandleList} span={HandleTreeData} />
        <CardBody className='sortable-handler'>
          <ul className='list-group' ref={listRef}>
            {handlelistItems.map((item, index) => (
              <LI key={index} className={`${index % 2 === 0 ? "light-background" : ""}`}>
                <i className='fa fa-arrows handle'></i>
                {item}
              </LI>
            ))}
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SortableHandleList;
